import { useRouter } from "next/router";
import { useContext, useMemo } from "react";

import { PreviewModeContext } from "../providers/PreviewMode";

const BASE_URL =
  typeof window !== "undefined" ? window.location.origin : "https://endr.co";

export function useUTMLink(link: string): string;
export function useUTMLink(link: string | null | undefined): string | undefined;
export function useUTMLink(
  link: string | null | undefined,
): string | undefined {
  const router = useRouter();
  const { isPreviewMode } = useContext(PreviewModeContext);

  return useMemo(() => {
    if (!link) {
      return undefined;
    }

    const url = new URL(link, BASE_URL);

    if (isPreviewMode) {
      url.searchParams.set("in_preview_mode", "true");
      return url.href.replace(url.origin, "");
    }

    const utm = {
      utm_source: router.query.utm_source,
      utm_medium: router.query.utm_medium,
      utm_campaign: router.query.utm_campaign,
      utm_content: router.query.utm_content,
      utm_term: router.query.utm_term,
    };

    for (const [key, value] of Object.entries(utm)) {
      if (typeof value === "string") {
        url.searchParams.append(key, value);
      } else if (Array.isArray(value)) {
        for (const v of value) {
          url.searchParams.append(key, v);
        }
      }
    }

    return url.href.replace(url.origin, "");
  }, [link, router.query, isPreviewMode]);
}
